import * as React from 'react';
import TwoColRow from './TwoColRow';
const PropertyOwnershipSummary = ({ value, i18n, formatDate }) => {
    const propertiesToUse = [
        'numberOfProperties',
        'assessedTotal',
        'assessedOfBuilding',
        'assessedOfLand',
        'assessedOfOwnedPart'
    ];
    return (React.createElement(React.Fragment, null,
        React.createElement("div", null, Object.keys(value)
            .filter(prop => propertiesToUse.includes(prop))
            .map(key => {
            return (React.createElement(TwoColRow, { label: i18n(`controlpoint.propertyOwnership.${key}`), value: value[key] }));
        }))));
};
export default PropertyOwnershipSummary;
